<!-- Une ligne par adresse (PC-10) : la commune, puis son climat et ses zones.
     Elle ouvre la fiche du potager. -->
<vw-list-row [title]="placeLabel"
  [subtitle]="summary"
  (rowClick)="onOpenGarden()">
  <vw-location-home-icon vwListRowIcon class="block h-6 w-6" />
</vw-list-row>
<vw-garden-address-toast [isOpen]="isGardenOpen" [address]="address" [climateLabel]="climateLabel"
  [locations]="locations" [zonesLabel]="zonesLabel" (close)="onCloseGarden()"></vw-garden-address-toast>
